/* eslint-disable prettier/prettier */
import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import useTranslation from 'next-translate/useTranslation';
import SuccessImage from '@public/images/register-success.png';
import { APP_ROUTES } from '@constants/constants';

export const SuccessMessage = () => {
  const { t } = useTranslation('register');
  const router = useRouter();

  useEffect(() => {
    const timer = setTimeout(() => {
      router.push(APP_ROUTES.WEBSHOP);
    }, 10000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <Row>
        <Col className="mb-3">
          <a href={APP_ROUTES.WEBSHOP}>
            <Image src={SuccessImage} width={1200} height={600} alt={t('body.success-message')} layout="responsive" />
          </a>
        </Col>
      </Row>
    </Container>
  );
};
